import { render } from "./PendingApprovalView.vue?vue&type=template&id=27f8d12c"
import script from "./PendingApprovalView.vue?vue&type=script&lang=js"
export * from "./PendingApprovalView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__